var _projectName = window._projectName || {};



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/modules/globals.js